function onsiteLoaded() { // NOSONAR
  var neb_status = KAMPYLE_ONSITE_SDK.loadForm(35999);// NOSONAR

  if (neb_status === true) {
    document.getElementById('mdFormButton').style.display = 'inherit';
  }
}

if (window.KAMPYLE_ONSITE_SDK) {
  onsiteLoaded();
} else {
  window.addEventListener('neb_OnsiteLoaded', onsiteLoaded);
}
